export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14985.00d471c0.jpg";